import {doDispatch} from "../Dispatcher";
import {login} from "../../services/self";

export const ActionTypes = {
    LOGIN_REQUEST_RECEIVED: 'LOGIN_REQUEST_RECEIVED',
    LOGIN_AUTHENTICATING: 'LOGIN_AUTHENTICATING',
    LOGIN_AUTHENTICATION_INPUT_RECEIVED: 'LOGIN_AUTHENTICATION_INPUT_RECEIVED',
    LOGIN_AUTHENTICATION_SUCCESS: 'LOGIN_AUTHENTICATION_SUCCESS',
    LOGIN_AUTHENTICATION_FAILED: 'LOGIN_AUTHENTICATION_FAILED',
};

export function loginFromHomePageRequestReceived(usagePlanId, token, isAuthenticated) {
    doDispatch({
        type: ActionTypes.LOGIN_REQUEST_RECEIVED,
        isAuthenticated: isAuthenticated
    });
}

export function formReceivedUserInput(event, inputProps) {
    doDispatch({
        type: ActionTypes.LOGIN_AUTHENTICATION_INPUT_RECEIVED,
        formFieldName: inputProps.name,
        formFieldValue: inputProps.value
    });
}

export function submitLogin(email, password) {
    doDispatch({
        type: ActionTypes.LOGIN_AUTHENTICATING,
        message: `Logging in...`
    });

    try {
        const loginPromise = login(email, password);

        loginPromise.then(() => {
            doDispatch({
                type: ActionTypes.LOGIN_AUTHENTICATION_SUCCESS
            });
        }).catch((e) => {
            doDispatch({
                type: ActionTypes.LOGIN_AUTHENTICATION_FAILED,
                message: e.message
            });
        })
    } catch (e) {
        doDispatch({
            type: ActionTypes.LOGIN_AUTHENTICATION_FAILED,
            message: e.message
        });
    }
}


/** WEBPACK FOOTER **
 ** ./src/shared_states/LoginFromHomePageRequest/Actions.js
 **/